var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 1.66675H2.33398V6.66675M2.33398 18.3334V23.3334H7.33398M30.6673 23.3334H35.6673V18.3334M35.6673 6.66675V1.66675H30.6673M19.0007 21.6667C14.399 21.6667 10.6673 17.9351 10.6673 13.3334V11.6667C10.6673 7.06508 14.399 3.33341 19.0007 3.33341C23.6023 3.33341 27.334 7.06508 27.334 11.6667V13.3334C27.334 17.9351 23.6023 21.6667 19.0007 21.6667ZM35.6673 36.3417C35.6673 33.3334 33.659 30.7101 30.759 29.9084C27.8607 29.1067 23.8173 28.3334 19.0007 28.3334C14.184 28.3334 10.1407 29.1067 7.24232 29.9084C4.34232 30.7117 2.33398 33.3334 2.33398 36.3417V38.3334H35.6673V36.3417Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile-picture.4353c3d2.svg";
export { ForwardRef as ReactComponent };